<template>
  <component
    :is="tag"
    class="mention-pill"
    :class="{ '-many': users.length > 1 }"
  >
    <FAIcon
      v-if="reply"
      class="mention-pill-reply"
      :class="{ '-strikethrough': !reply.statusId }"
      icon="reply-to"
    />
    <span
      class="mention-pill-faces"
      aria-hidden="true"
    >
      <template
        v-for="(user, index) in users"
        :key="index"
      >
        <img
          v-if="user.profile_image_url && !failed.has(index)"
          class="mention-pill-avatar"
          :src="user.profile_image_url"
          alt=""
          @error="fail(index)"
        ><span
          v-else
          class="mention-pill-avatar -initial"
        >{{ initial(user) }}</span>
      </template>
    </span>
    <slot />
  </component>
</template>

<script>
import { userInitial } from 'src/services/user_display/user_display.js'

// The body of every mention pill, for one person or several: the reply
// sign when the post replies to (the first of) them, their faces, then the
// label, a name or how many. What the pill does (a link, a hover card, a
// list that opens) is up to the one using it.
export default {
  name: 'MentionPill',
  props: {
    users: { type: Array, required: true },
    // { statusId } when the post replies to the first of them; struck
    // through when the replied-to post cannot be seen
    reply: { type: Object, default: null },
    tag: { type: String, default: 'span' },
  },
  data: () => ({ failed: new Set() }),
  methods: {
    initial: userInitial,
    fail(index) {
      this.failed = new Set(this.failed).add(index)
    },
  },
}
</script>

<style lang="scss" src="./mention_pill.scss" />
